import type { IConfigCatLogger, LogEventId, LogMessage } from "configcat-js";
import { createConsoleLogger, LogLevel } from "configcat-js";

export class CustomConfigCatLogger implements IConfigCatLogger {
  private readonly _IGNORED_EVENT_MATCHERS = [
    "Unexpected HTTP response was received while trying to fetch config JSON:",
    "Unexpected error occurred while trying to fetch config JSON.",
  ];

  constructor(private readonly _configCatLogger = createConsoleLogger(LogLevel.Warn)) {}

  log(level: LogLevel, eventId: LogEventId, message: LogMessage, exception?: any): void {
    if (this._shouldBeIgnored(message.toString())) {
      return;
    }

    this._configCatLogger.log(level, eventId, message, exception);
  }

  _shouldBeIgnored(message: string): boolean {
    const doesMatchWithSomeOfTheIgnoredEventMatchers = this._IGNORED_EVENT_MATCHERS.some(
      function checkIfStartsWithMatche(this: CustomConfigCatLogger, matcher: string) {
        return this._doesLogMessageStartWithIgnoredEventMatcher(matcher, message);
      }.bind(this)
    );
    return doesMatchWithSomeOfTheIgnoredEventMatchers;
  }

  _doesLogMessageStartWithIgnoredEventMatcher(matcher: string, message: string): boolean {
    const doesMatchWithSomeOfTheIgnoredEventMatchers = message.startsWith(matcher);
    return doesMatchWithSomeOfTheIgnoredEventMatchers;
  }
}
